(() => {
  if (window.MasterCartCroLoaded) return;
  window.MasterCartCroLoaded = true;

  const motionClasses = [
    'master-atc-motion','master-atc-motion--pulse','master-atc-motion--bounce','master-atc-motion--shake','master-atc-motion--glow','master-atc-motion--sheen',
    'master-atc-motion--subtle','master-atc-motion--normal','master-atc-motion--strong'
  ];
  const sizeClasses = [
    'master-cart-cro--reassurance-compact','master-cart-cro--reassurance-comfortable','master-cart-cro--reassurance-large',
    'master-cart-cro--benefits-compact','master-cart-cro--benefits-comfortable','master-cart-cro--benefits-large',
    'master-cart-cro--trust-compact','master-cart-cro--trust-comfortable','master-cart-cro--trust-large',
    'master-cart-cro--trust-cards','master-cart-cro--trust-pills','master-cart-cro--trust-minimal'
  ];
  const getCfg = () => document.querySelector('[data-master-cart-cro-config]')?.dataset || null;
  const truthy = value => value === true || ['true','1','on','yes'].includes(String(value || '').toLowerCase());
  const esc = value => String(value ?? '').replace(/[&<>'"]/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
  /* Mismo formato que el filtro `money` de Liquid; ver assets/master-money.js. */
  const money = cents => window.MasterCart?.money ? window.MasterCart.money(cents) : window.MasterMoney ? window.MasterMoney.format(cents) : new Intl.NumberFormat(document.documentElement.lang || undefined,{style:'currency',currency:window.MasterTheme?.currency || window.Shopify?.currency?.active,maximumFractionDigits:0}).format((Number(cents)||0)/100);
  /* Copia de sistema desde locales/; ver layout/theme.liquid. */
  const t = (key,vars) => window.MasterTheme?.t?.(key,vars) ?? '';
  let lastCart = null;
  let bundleTransaction = null;
  let bundleTransactionSeq = 0;

  const cartCount = root => {
    const local = Number(root?.dataset?.itemCount);
    const drawer = Number(document.querySelector('[data-drawer-count]')?.textContent);
    const lines = root?.querySelectorAll?.('[data-line-key],[data-cart-page-line]')?.length || 0;
    return Math.max(Number.isFinite(drawer) ? drawer : 0, Number.isFinite(local) ? local : 0, lines ? 1 : 0);
  };

  const restartMotion = btn => {
    btn.style.animation = 'none';
    void btn.offsetWidth;
    btn.style.removeProperty('animation');
  };

  const applyColors = (root,cfg) => {
    ['--master-accent','--master-bg','--master-soft','--master-text'].forEach(name => root.style.removeProperty(name));
    if (truthy(cfg.useThemeColors)) return;
    if (cfg.accent) root.style.setProperty('--master-accent',cfg.accent);
    if (cfg.background) root.style.setProperty('--master-bg',cfg.background);
    if (cfg.soft) root.style.setProperty('--master-soft',cfg.soft);
    if (cfg.text) root.style.setProperty('--master-text',cfg.text);
  };

  const applySizes = (root,cfg) => {
    sizeClasses.forEach(c => root.classList.remove(c));
    root.classList.add(`master-cart-cro--reassurance-${cfg.reassuranceSize || 'comfortable'}`);
    root.classList.add(`master-cart-cro--benefits-${cfg.benefitsSize || 'comfortable'}`);
    root.classList.add(`master-cart-cro--trust-${cfg.trustSize || 'comfortable'}`);
    root.classList.add(`master-cart-cro--trust-${cfg.trustStyle || 'cards'}`);
  };

  const applyMotion = (root,cfg) => {
    root.querySelectorAll('[data-cart-cro-cta]').forEach(btn => {
      motionClasses.forEach(c => btn.classList.remove(c));
      btn.style.removeProperty('--cta-motion-interval');
      if (!truthy(cfg.checkoutMotion)) return;
      btn.classList.add('master-atc-motion',`master-atc-motion--${cfg.motionType || 'bounce'}`,`master-atc-motion--${cfg.motionStrength || 'strong'}`);
      btn.style.setProperty('--cta-motion-interval',`${Math.max(1,Number(cfg.motionInterval||2))}s`);
      restartMotion(btn);
    });
  };

  const applyReassurance = (root,cfg,active) => {
    root.querySelectorAll('[data-cart-cro-reassurance]').forEach(el => {
      const show = truthy(cfg.reassuranceShow) && active;
      el.hidden = !show;
      if (show) el.removeAttribute('hidden');
      const rating = el.querySelector('[data-cart-cro-rating]');
      const text = el.querySelector('[data-cart-cro-reassurance-text]');
      if (rating) rating.textContent = cfg.rating || '';
      if (text) text.textContent = cfg.reassuranceText || '';
    });
  };

  const makeBenefitGroup = items => {
    const group = document.createElement('div');
    group.className = 'master-cart-benefit-group';
    items.forEach(text => {
      const span = document.createElement('span');
      span.textContent = text;
      group.appendChild(span);
    });
    return group;
  };

  const ensureBenefitMarquee = root => {
    let el = root.querySelector('[data-cart-benefit-marquee]');
    if (el) return el;
    el = document.createElement('div');
    el.className = 'master-cart-benefit-marquee';
    el.dataset.cartBenefitMarquee = '';
    el.setAttribute('aria-label','Beneficios de compra');
    const track = document.createElement('div');
    track.className = 'master-cart-benefit-track';
    track.dataset.cartBenefitTrack = '';
    el.appendChild(track);
    const reassurance = root.querySelector('[data-cart-cro-reassurance]');
    if (reassurance) reassurance.before(el);
    else root.querySelector('[data-cart-cro-cta]')?.before(el);
    return el;
  };

  // `hidden` por si solo no apaga la cinta: `.is-active` y el display inline
  // que pone applyBenefits ganan por orden y por origen al `[hidden]` de
  // master-base.css. Apagarla es quitar las tres cosas a la vez.
  const hideBenefitMarquee = el => {
    el.hidden = true;
    el.classList.remove('is-active');
    el.style.removeProperty('display');
  };

  const applyBenefits = (root,cfg,active) => {
    const el = ensureBenefitMarquee(root);
    if (!el) return;
    const show = truthy(cfg.benefitsShow) && active;
    el.classList.toggle('is-active',show);
    if (!show) { hideBenefitMarquee(el); return; }
    el.hidden = false;
    el.removeAttribute('hidden');
    el.style.display = 'block';
    const track = el.querySelector('[data-cart-benefit-track]');
    if (!track) return;
    const items = [cfg.benefitOne,cfg.benefitTwo,cfg.benefitThree].map(v => String(v || '').trim()).filter(Boolean);
    if (!items.length) {
      // Sin copy del merchant no hay cinta que mover. Si la plantilla ya
      // imprimio beneficios propios eso SI es contenido y se respeta; lo que no
      // puede quedar es el riel vacio, que en /cart pintaba un rectangulo con
      // borde de 40px entre el Subtotal y el CTA sin decir nada.
      const printed = [...track.querySelectorAll('span')].some(span => span.textContent.trim());
      if (!printed) hideBenefitMarquee(el);
      return;
    }
    track.replaceChildren(makeBenefitGroup(items),makeBenefitGroup(items));
    track.style.setProperty('--cart-benefit-speed',`${Math.max(6,Number(cfg.benefitSpeed||12))}s`);
    track.style.animation = 'none';
    void track.offsetWidth;
    track.style.removeProperty('animation');
  };

  // Los textos siguen siendo del merchant; lo que cambia es el respaldo cuando
  // los deja en blanco. «Envíos a Colombia» como fallback ataba el motor a un
  // país: la misma instalación en México o EE. UU. mentía por defecto.
  const trustItems = cfg => [
    [cfg.trustOneIcon || '📦',cfg.trustOneText || t('trustCod')],
    [cfg.trustTwoIcon || '🚚',cfg.trustTwoText || t('trustShipping')],
    [cfg.trustThreeIcon || '🛡️',cfg.trustThreeText || t('trustProtected')]
  ];
  const applyTrust = (root,cfg,active) => {
    root.querySelectorAll('[data-cart-cro-trust]').forEach(wrap => {
      const items = trustItems(cfg);
      let shown = 0;
      wrap.querySelectorAll('[data-cart-trust-item]').forEach((item,index) => {
        const pair = items[index] || ['', ''];
        const icon = item.querySelector('[data-cart-trust-icon]');
        const text = item.querySelector('[data-cart-trust-text]');
        if (icon) icon.textContent = pair[0];
        if (text) text.textContent = pair[1];
        if (pair[1]) shown += 1;
        // Un icono sin texto no afirma nada por sí solo: lo que decide si el
        // badge es una promesa es el texto, no el emoji decorativo. Gatear
        // sólo por icono dejaba el badge visible con el emoji de fallback
        // aunque el texto quedara vacío a propósito.
        item.hidden = !pair[1];
      });
      // Con cero badges validos el wrapper solo aportaria su rejilla y su
      // separacion: se apaga entero en vez de dejar el hueco.
      wrap.hidden = !active || shown === 0;
      if (!wrap.hidden) wrap.removeAttribute('hidden');
    });
  };

  const domCart = root => {
    const items = [...root.querySelectorAll('[data-line-key],[data-cart-page-line]')].map(line => ({
      key: line.dataset.lineKey || '',
      product_id: Number(line.dataset.productId || 0),
      variant_id: Number(line.dataset.variantId || 0),
      quantity: Number(line.dataset.lineQty || line.querySelector('[data-cart-page-input]')?.value || line.querySelector('.master-cart-qty span')?.textContent || 0),
      original_price: Number(line.dataset.lineOriginalUnit || 0),
      final_price: Number(line.dataset.lineFinalUnit || 0),
      // El total de linea REAL cuando el servidor lo emite; multiplicar el
      // unitario redondeado por la cantidad no reconstruye el total. Con
      // 209.900 entre 3, el unitario redondea a 69.966,67 y el producto daba
      // 209.900,01: un centimo inventado en pantalla.
      original_line_price: line.dataset.lineOriginalTotal !== undefined
        ? Number(line.dataset.lineOriginalTotal)
        : Number(line.dataset.lineOriginalUnit || 0) * Number(line.dataset.lineQty || 0),
      final_line_price: line.dataset.lineFinalTotal !== undefined
        ? Number(line.dataset.lineFinalTotal)
        : Number(line.dataset.lineFinalUnit || 0) * Number(line.dataset.lineQty || 0)
    })).filter(item => item.quantity > 0);
    return {item_count:items.reduce((sum,item)=>sum+item.quantity,0),items,total_discount:0,cart_level_discount_applications:[]};
  };

  const tierConfig = cfg => {
    const tiers = [
      {slot:'one',qty:Number(cfg.bundleTierOneQty||1),title:cfg.bundleTierOneTitle||'1 unidad',note:cfg.bundleTierOneNote||'',badge:cfg.bundleTierOneBadge||'',badgeKind:cfg.bundleTierOneBadgeKind||'qualitative',saveType:cfg.bundleTierOneSaveType||'none',saveValue:cfg.bundleTierOneSaveValue||0,code:String(cfg.bundleTierOneCode||'').trim(),descriptor:String(cfg.bundleTierOneDescriptor||'').trim()},
      {slot:'two',qty:Number(cfg.bundleTierTwoQty||2),title:cfg.bundleTierTwoTitle||'2 unidades',note:cfg.bundleTierTwoNote||'',badge:cfg.bundleTierTwoBadge||'',badgeKind:cfg.bundleTierTwoBadgeKind||'qualitative',saveType:cfg.bundleTierTwoSaveType||'none',saveValue:cfg.bundleTierTwoSaveValue||0,code:String(cfg.bundleTierTwoCode||'').trim(),descriptor:String(cfg.bundleTierTwoDescriptor||'').trim()}
    ];
    if (truthy(cfg.bundleTierThreeShow)) tiers.push({slot:'three',qty:Number(cfg.bundleTierThreeQty||3),title:cfg.bundleTierThreeTitle||'3 unidades',note:cfg.bundleTierThreeNote||'',badge:cfg.bundleTierThreeBadge||'',badgeKind:cfg.bundleTierThreeBadgeKind||'qualitative',saveType:cfg.bundleTierThreeSaveType||'none',saveValue:cfg.bundleTierThreeSaveValue||0,code:String(cfg.bundleTierThreeCode||'').trim(),descriptor:String(cfg.bundleTierThreeDescriptor||'').trim()});
    return tiers.filter(tier => tier.qty > 0).sort((a,b)=>a.qty-b.qty);
  };

  const activeDiscountCodes = cart => {
    if (window.MasterCart?.activeDiscountCodes) return window.MasterCart.activeDiscountCodes(cart);
    // Reserva con la misma tolerancia de forma que master-cart.js: GET /cart.js
    // entrega la aplicacion plana y POST /cart/update.js la entrega envuelta en
    // {amount, discount_application}. Ver el comentario largo alli.
    const unwrap = entry => entry?.discount_application || entry;
    const apps = (cart?.cart_level_discount_applications || []).map(unwrap);
    (cart?.items || []).forEach(item => (item.line_level_discount_allocations || []).forEach(allocation => {
      const app = unwrap(allocation);
      if (app) apps.push(app);
    }));
    return [...new Set(apps.filter(app => ['discount_code','code'].includes(String(app?.type || '').toLowerCase())).map(app => String(app?.title || '').trim()).filter(Boolean))];
  };

  const targetProductId = (cfg,cart,root) => Number(cfg.bundleProductId || 0) || Number(cart?.items?.[0]?.product_id || root.querySelector('[data-product-id]')?.dataset.productId || 0);
  const targetItems = (cart,productId) => (cart?.items || []).filter(item => !productId || Number(item.product_id) === Number(productId));
  const targetQty = (cart,productId) => targetItems(cart,productId).reduce((sum,item)=>sum+Number(item.quantity||0),0);
  const targetOriginalTotal = (cart,productId) => targetItems(cart,productId).reduce((sum,item)=>sum+Number(item.original_line_price ?? (item.original_price||0)*(item.quantity||0)),0);
  const targetFinalTotal = (cart,productId) => targetItems(cart,productId).reduce((sum,item)=>sum+Number(item.final_line_price ?? (item.final_price||0)*(item.quantity||0)),0);
  const baseUnit = (cart,productId) => {
    const item = targetItems(cart,productId)[0];
    if (!item) return 0;
    return Number(item.original_price || item.final_price || 0);
  };

  const ensureBundle = root => root.querySelector('[data-cart-bundle-shell]');
  const renderBundle = (root,cfg,cart) => {
    const shell = ensureBundle(root);
    if (!shell) return;
    const onCartPage = root.dataset.cartCroLocation === 'cart-page';
    const show = truthy(cfg.bundleShow) && (!onCartPage || truthy(cfg.bundleCartPage)) && cartCount(root) > 0;
    shell.hidden = !show;
    if (!show) { shell.innerHTML=''; return; }
    const data = cart?.items ? cart : domCart(root);
    const pid = targetProductId(cfg,data,root);
    const items = targetItems(data,pid);
    if (!items.length) { shell.hidden=true; shell.innerHTML=''; return; }
    const qty = targetQty(data,pid);
    const unit = baseUnit(data,pid);
    const actualOriginal = targetOriginalTotal(data,pid);
    const actualFinal = targetFinalTotal(data,pid);
    const actualSave = Math.max(0,actualOriginal-actualFinal);
    const tiers = tierConfig(cfg);
    // El drawer mide ~405px de contenido en cualquier viewport, asi que tres
    // columnas dejan 124px por nivel cuando el badge solo ya ocupa 98px: los
    // niveles 2 y 3 se recortaban. En drawer nunca se permiten cards; en /cart
    // las cards solo tienen sentido con ancho real y el CSS las degrada a filas
    // por debajo de 1000px.
    const requestedStyle = onCartPage ? (cfg.bundleCartStyle || cfg.bundleStyle) : cfg.bundleStyle;
    const allowedStyles = onCartPage ? ['rows','compact','cards'] : ['rows','compact'];
    const style = allowedStyles.includes(requestedStyle) ? requestedStyle : 'rows';
    // Modelo de display explicito por nivel:
    //   seleccionado    -> cifras REALES del carrito de Shopify.
    //   no seleccionado -> PROYECCION de la ventaja declarada, marcada como
    //                      "desde", mas el descriptor del merchant si existe.
    //
    // La proyeccion es orientacion comercial ANTES de mutar el carrito: sin
    // carrito, Shopify no puede cotizar el nivel. Antes se proyectaba siempre
    // lineal (2 uds = 159.800) mientras la pagina de producto ya anunciaba
    // 149.900, asi que la escalera INFRAVALORABA la oferta. Ahora ambas
    // superficies proyectan lo mismo porque usan la misma regla.
    //
    // `bundle_discount_mode` es la declaracion del merchant sobre quien entrega
    // la ventaja: con 'none' no hay ninguna y nada puede afirmar lo contrario.
    const advantageIsReal = String(cfg.bundleDiscountMode || 'none') !== 'none';
    const source = advantageIsReal ? 'automatic' : 'none';
    // Una sola aritmetica en todo el theme: assets/master-offer.js. Sin el, se
    // cae a lineal, que es lo conservador.
    const projectTier = tier => window.MasterOffer
      ? window.MasterOffer.resolveTier({unitPrice: unit, qty: tier.qty, source, saveType: tier.saveType, saveValue: tier.saveValue})
      : {reference: unit * tier.qty, price: unit * tier.qty, advantage: 0, unitPrice: unit, hasAdvantage: false};

    const buttons = tiers.map(tier => {
      const selected = qty === tier.qty;
      const projection = projectTier(tier);
      const price = selected && actualFinal ? actualFinal : projection.price;
      // Misma regla de unidad mayor que el selector de la ficha: si no, el
      // carrito enseñaba «$69.966,67 c/u» donde la ficha ya decía «$69.967 c/u».
      const unitPrice = tier.qty > 0 && price
        ? (window.MasterOffer ? window.MasterOffer.unitPriceFor(price, tier.qty) : Math.round(price / tier.qty))
        : unit;
      const realSave = selected ? actualSave : 0;

      // El tachado del nivel seleccionado sale del carrito real; el del nivel
      // proyectado, de la ventaja declarada. Nunca se muestra un tachado sin
      // una de las dos detras.
      const showProjectedStrike = !selected && projection.hasAdvantage && projection.reference > projection.price;

      // El ahorro real lo comunica la cabecera de la seccion; repetirlo en el
      // nivel seleccionado mostraba la misma cifra dos veces. Aqui queda el
      // tachado, que es comparacion, no una segunda promesa de ahorro.
      const priceBlock = selected
        ? `${realSave > 0 ? `<s>${money(actualOriginal)}</s>` : ''}<b>${price ? money(price) : '—'}</b>`
        : `${showProjectedStrike ? `<s>${money(projection.reference)}</s>` : ''}<b>${price ? money(price) : '—'}</b>`;

      const support = selected
        ? (unitPrice ? `${money(unitPrice)} ${t('each')}` : '')
        : [tier.descriptor, unitPrice ? `${t('from')} ${money(unitPrice)} ${t('each')}` : ''].filter(Boolean).join(' · ');

      // El badge va DENTRO de la columna de texto, no posicionado en absoluto:
      // anclado sobre el recuadro se solapaba y se recortaba en cuanto el
      // titulo o el precio crecian.
      // Misma regla que el selector de producto: un badge comparativo afirma un
      // precio mejor y sólo se pinta si hay una fuente de descuento real detrás.
      // Con `none` los niveles cuestan cantidad x precio, asi que MEJOR VALOR
      // seria falso aqui igual que lo era en la pagina de producto.
      const showBadge = Boolean(tier.badge) && (tier.badgeKind !== 'comparative' || advantageIsReal);

      return `<button type="button" class="master-cart-bundle__tier${selected ? ' is-selected' : ''}${showBadge ? ' has-badge' : ''}" data-bundle-tier data-bundle-qty="${tier.qty}" data-bundle-code="${esc(tier.code)}" aria-pressed="${selected ? 'true' : 'false'}">
        <span class="master-cart-bundle__mark" aria-hidden="true">${selected ? '✓' : ''}</span>
        <span class="master-cart-bundle__text">
          <span class="master-cart-bundle__titleline"><strong>${esc(tier.title)}</strong>${showBadge ? `<em class="master-cart-bundle__badge">${esc(tier.badge)}</em>` : ''}</span>
          ${tier.note ? `<small class="master-cart-bundle__note">${esc(tier.note)}</small>` : ''}
        </span>
        <span class="master-cart-bundle__price">${priceBlock}${support ? `<small class="master-cart-bundle__unit">${esc(support)}</small>` : ''}</span>
      </button>`;
    }).join('');

    // Reconciliacion: el nivel seleccionado ya paso por Shopify, asi que se
    // compara lo proyectado contra lo cobrado. El precio mostrado siempre es el
    // real —arriba se usa `actualFinal`, nunca la proyeccion— pero un desajuste
    // significa que la promocion de Shopify no coincide con lo declarado y hay
    // que decirlo en vez de dejar la escalera prometiendo de mas.
    const selectedTier = tiers.find(tier => tier.qty === qty);
    if (selectedTier && advantageIsReal && window.MasterOffer) {
      const expected = projectTier(selectedTier);
      if (expected.advantage > 0 && Math.abs(expected.advantage - actualSave) > 1) {
        console.warn(
          `[MASTER] La escalera proyectaba ${expected.advantage} de ventaja para ${qty} uds y Shopify aplico ${actualSave}. ` +
          'Se muestra la cifra real de Shopify. Revisa que la promocion por cantidad coincida con la ventaja configurada.'
        );
        shell.dataset.bundleMismatch = String(actualSave - expected.advantage);
      } else {
        delete shell.dataset.bundleMismatch;
      }
    } else {
      delete shell.dataset.bundleMismatch;
    }

    const showStatus = truthy(cfg.bundleShowStatus);
    shell.innerHTML = `<div class="master-cart-bundle master-cart-bundle--${style} master-cart-bundle--${onCartPage?'page':'drawer'}" data-cart-bundle data-product-id="${pid}">
      <div class="master-cart-bundle__head"><div><span>${esc(cfg.bundleHeading||'MEJORA TU OFERTA')}</span>${cfg.bundleSubheading?`<small>${esc(cfg.bundleSubheading)}</small>`:''}</div>${actualSave>0?`<strong>${esc(t('savings'))} ${money(actualSave)}</strong>`:''}</div>
      <div class="master-cart-bundle__tiers">${buttons}</div>
      <div class="master-cart-bundle__status${showStatus?'':' is-visually-hidden'}" data-bundle-status aria-live="polite">${esc(cfg.bundleStatusReady||'Oferta actualizada correctamente')}</div>
    </div>`;
    shell.removeAttribute('hidden');
    if (bundleTransaction) setBundleBusy(shell.querySelector('[data-cart-bundle]'),true,cfg.bundleStatusBusy || 'Actualizando oferta…');
  };

  const setBundleBusy = (bundle,busy,text='') => {
    bundle?.classList.toggle('is-busy',busy);
    bundle?.querySelectorAll('[data-bundle-tier]').forEach(btn => btn.disabled = busy);
    const status = bundle?.querySelector('[data-bundle-status]');
    if (status && text) status.textContent = text;
  };

  const setBundleTransactionLock = (active, message = '') => {
    document.documentElement.classList.toggle('master-bundle-transaction', active);
    document.querySelectorAll('[data-cart-bundle]').forEach(bundle => setBundleBusy(bundle,active,message));
    document.querySelectorAll('[data-cart-page-form]').forEach(form => {
      if (active) form.setAttribute('aria-busy','true'); else form.removeAttribute('aria-busy');
    });
  };

  const authoritativeCart = async () => {
    if (!window.MasterCart?.getCart) return lastCart;
    return window.MasterCart.getCart({render:false});
  };

  const handleBundleTier = async button => {
    const bundle = button.closest('[data-cart-bundle]');
    const root = button.closest('[data-cart-cro-root]');
    const cfg = getCfg();
    if (!bundle || !root || !cfg || !window.MasterCart?.setProductQuantity || bundleTransaction) return;

    const pid = Number(bundle.dataset.productId || 0);
    const qty = Math.max(1,Number(button.dataset.bundleQty || 1));
    const code = String(button.dataset.bundleCode || '').trim();
    const transactionId = ++bundleTransactionSeq;

    bundleTransaction = (async () => {
      setBundleTransactionLock(true,cfg.bundleStatusBusy || 'Actualizando oferta…');
      try {
        // Capturamos los códigos antes de mover cantidad. Una promoción por cantidad puede
        // cambiar las keys de línea; el carrito final de Shopify siempre será la autoridad.
        const before = await authoritativeCart();
        const preservedBefore = activeDiscountCodes(before);
        let cart = await window.MasterCart.setProductQuantity(pid,qty,{render:false});

        const mode = cfg.bundleDiscountMode || 'automatic';
        if (mode === 'codes') {
          const allBundleCodes = tierConfig(cfg).map(tier => tier.code.toLowerCase()).filter(Boolean);
          const preserve = truthy(cfg.bundlePreserveOtherDiscounts);
          let codes = preserve ? preservedBefore.filter(c => !allBundleCodes.includes(c.toLowerCase())) : [];
          if (code) codes.push(code);
          codes = [...new Set(codes.map(v => v.trim()).filter(Boolean))];
          try {
            cart = await window.MasterCart.applyDiscount(codes.join(','),{render:false});
          } catch (discountError) {
            // La cantidad sí queda aplicada. Shopify decide elegibilidad/combinación del código.
            console.error(discountError);
            cart = await authoritativeCart();
          }
        }

        // Relectura final obligatoria: evita UI optimista o datos viejos cuando un descuento
        // automático/código cambia line_item.key o el precio después de modificar cantidad.
        cart = await authoritativeCart();
        if (targetQty(cart,pid) !== qty) {
          cart = await window.MasterCart.setProductQuantity(pid,qty,{render:false});
          if (mode === 'codes') {
            const allBundleCodes = tierConfig(cfg).map(tier => tier.code.toLowerCase()).filter(Boolean);
            const preserve = truthy(cfg.bundlePreserveOtherDiscounts);
            let retryCodes = preserve ? preservedBefore.filter(c => !allBundleCodes.includes(c.toLowerCase())) : [];
            if (code) retryCodes.push(code);
            retryCodes = [...new Set(retryCodes.map(v => v.trim()).filter(Boolean))];
            try { cart = await window.MasterCart.applyDiscount(retryCodes.join(','),{render:false}); } catch (_) {}
          }
          cart = await authoritativeCart();
        }
        if (targetQty(cart,pid) !== qty) throw new Error('No pudimos confirmar la cantidad seleccionada. Inténtalo de nuevo.');

        lastCart = cart;
        window.MasterCart.commitCart?.(cart,`Oferta actualizada a ${qty} unidad${qty===1?'':'es'}.`);
        document.querySelectorAll('[data-cart-cro-root]').forEach(cartRoot => renderBundle(cartRoot,cfg,cart));
      } catch (error) {
        console.error(error);
        const current = root.querySelector('[data-cart-bundle]');
        const status = current?.querySelector('[data-bundle-status]');
        if (status) status.textContent = error?.message || cfg.bundleStatusError || 'No se pudo actualizar la oferta.';
        const fresh = await authoritativeCart().catch(() => null);
        if (fresh) {
          lastCart = fresh;
          window.MasterCart.commitCart?.(fresh);
        }
      } finally {
        if (transactionId === bundleTransactionSeq) setBundleTransactionLock(false);
      }
    })();

    try { await bundleTransaction; } finally { bundleTransaction = null; }
  };

  const applyRoot = root => {
    const cfg = getCfg();
    if (!cfg) return;
    const active = cartCount(root) > 0;
    applyColors(root,cfg);
    applySizes(root,cfg);
    applyMotion(root,cfg);
    applyBenefits(root,cfg,active);
    applyReassurance(root,cfg,active);
    applyTrust(root,cfg,active);
    renderBundle(root,cfg,lastCart || domCart(root));
  };

  const apply = () => {
    const cfg = getCfg();
    if (!cfg) return;
    document.querySelectorAll('[data-cart-cro-root]').forEach(applyRoot);
    document.dispatchEvent(new CustomEvent('master:cart-cro-config',{detail:{config:{...cfg}}}));
  };

  let queued = false;
  const queueApply = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; apply(); });
  };

  document.addEventListener('click',event => {
    const tier = event.target.closest?.('[data-bundle-tier]');
    if (tier) { event.preventDefault(); handleBundleTier(tier); }
  });
  apply();
  document.addEventListener('master:conversion-config',queueApply);
  document.addEventListener('master:cart-updated',event => { if (event.detail?.cart) lastCart = event.detail.cart; queueApply(); });
  document.addEventListener('shopify:section:load',queueApply);
  document.addEventListener('shopify:section:reorder',queueApply);
  document.addEventListener('shopify:section:select',queueApply);
  document.addEventListener('shopify:block:select',queueApply);

  if (window.Shopify?.designMode && 'MutationObserver' in window) {
    const selector = '[data-master-cart-cro-config],[data-cart-cro-root]';
    const observer = new MutationObserver(mutations => {
      const relevant = mutations.some(m => {
        if (m.target?.closest?.('[data-cart-benefit-track],[data-cart-bundle]')) return false;
        return [...m.addedNodes,...m.removedNodes].some(node => {
          if (node.nodeType !== 1) return false;
          return node.matches?.(selector) || node.querySelector?.(selector);
        });
      });
      if (relevant) queueApply();
    });
    observer.observe(document.documentElement,{childList:true,subtree:true});
  }
})();
